import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { DeleteEventContributorRolesDto } from '@/types/dtos/events/request/delete-event-contributor-roles.dto.ts';
import { GET_EVENT_CONTRIBUTORS_QUERY_KEY } from '../../queries/contributors/use-get-event-contributors.ts';

export const useDeleteEventContributorRoles = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: DeleteEventContributorRolesDto) => {
      const token = await getToken();
      return deleteEventContributorRoles(params, token ?? '');
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: [GET_EVENT_CONTRIBUTORS_QUERY_KEY],
      });
    },
  });
};

const deleteEventContributorRoles = async (data: DeleteEventContributorRolesDto, token: string) => {
  const url = `${import.meta.env.VITE_API_URL}/contributors/${data.contributorId}/roles`;
  return sendJSONRequest({
    url,
    method: METHOD.DELETE,
    token,
    body: data,
  });
};
